export default {
  authToken: null,
  user: {},
  officeLogin: false,
  agentData: null,
  additionalAccessData: null,
  currentProfile: null,
  // access: full | empty | demo
  //  full - as it says
  //  empty - student with full access but yet empty, blanked tabs
  //  demo - default, access only to limited online materials
  access: 'demo',
  isLogoutBlocked: false,
};
